import React, { useEffect, useRef } from 'react';
import { Edit2, Download, X } from 'lucide-react';
import styles from './ConversationMenu.scss';

const ConversationMenu = ({ 
  onRename, 
  onExport, 
  onDelete, 
  onClose, 
  isExporting 
}) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return (
    <div className={styles.conversationMenu} ref={menuRef} onClick={(e) => e.stopPropagation()}>
      <button
        className={styles.menuItem}
        onClick={(e) => {
          e.stopPropagation();
          onRename();
        }}
      >
        <Edit2 size={14} />
        <span>Rename</span>
      </button>
      
      <button
        className={styles.menuItem}
        onClick={(e) => {
          e.stopPropagation();
          onExport();
        }}
        disabled={isExporting}
      >
        <Download size={14} />
        <span>{isExporting ? 'Exporting...' : 'Export PDF'}</span>
      </button>
      
      <button
        className={`${styles.menuItem} ${styles.menuItemDanger}`}
        onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
      >
        <X size={14} />
        <span>Delete</span>
      </button>
    </div>
  );
};

export default ConversationMenu;

